<template>
  <div :class="['reupload-papery-material-btn', fixed ? 'fixed' : '']">
    <div class="content-box">
      <div class="left-box">
        <span v-if="unsubmited">请选择资料补充方式，仅支持单选</span>
        <span v-else>已选择在线上传资料</span>
      </div>

      <div class="right-box" v-if="unsubmited">
        <div class="btn-box" @click="onlineMaterialSumit">
          <img class="icon-box" src="../../../assets/imgs/upload/upload-icon.png" />
          <div class="text-box">
            <p class="title">在线上传资料</p>
            <p class="desc">电子资料</p>
          </div>
        </div>
        <div class="btn-box" @click="paperMaterialSumit">
          <img class="icon-box" src="../../../assets/imgs/upload/paper-icon.png" />
          <div class="text-box">
            <p class="title">线下邮寄资料</p>
            <p class="desc">纸质资料或原件</p>
          </div>
        </div>
      </div>

      <div class="right-box" v-else>
        <div class="edit-btn" @click="onlineMaterialSumit">
          修改补充资料
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unsubmited: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    paperMaterialSumit() {
      this.$emit('paperMaterialSumit');
    },
    onlineMaterialSumit() {
      this.$emit('onlineMaterialSumit');
    },
  },
};
</script>

<style lang="less">
.reupload-papery-material-btn {
  width: 100%;
	height: 100px;
	background-color: #5e9be1;
  opacity: 0.9;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .content-box{
    width: 1000px;
	  height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    .left-box{
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;
    }
    .right-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .edit-btn{
        width: 126px;
        height: 40px;
        background-color: #ffffff;
        border-radius: 4px;
        font-size: 14px;
        color: #5e9be1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .btn-box{
        width: 200px;
        height: 60px;
        border-radius: 4px;
        border: solid 1px #ffffff;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;
        &+.btn-box{
          margin-left: 30px;
        }
        &:hover{
          background-color: rgba(255, 255, 255, 0.1);
        }
        .text-box{
          margin-left: 20px;
          color: #ffffff;
          .title{
            font-size: 14px;
          }
          .desc{
            font-size: 12px;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.fixed{
  position: fixed;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/reupload/reupload-paper-online/reupload-papery-material-btn.vue